// These render on their own line, so flattening needs a separator or "One" and "Two" become "OneTwo".
const BLOCK_LEVEL_SELECTOR =
  'address,blockquote,br,dd,div,dl,dt,h1,h2,h3,h4,h5,h6,hr,li,ol,p,pre,table,td,th,tr,ul'

/** The visible text of a rich-text value, for emptiness checks, visible length and plain-text cells. */
export const htmlToPlainText = (html?: string | null) => {
  // Instantiated per call: at module level this would throw where DOMParser is undefined, such as
  // an SSR bundle importing anything from this barrel.
  const { body } = new DOMParser().parseFromString(html ?? '', 'text/html')

  body
    .querySelectorAll(BLOCK_LEVEL_SELECTOR)
    .forEach((element) => element.insertAdjacentText('afterend', ' '))

  return (body.textContent ?? '').replace(/\s+/g, ' ').trim()
}
